import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
  page: "",
  title: "",
  searchInput: "",
  typeValue: "",
  packageValue: "",
  industryValue: "",
  organisationValue: "",
  accessValue: "",
  reportsValue: [],
  organisationsValue: [],
  categoryValue: [],
  header: {
    page: "",
    mainTitle: "",
    title: "",
    subTitle: "",
    searchInput: "",
    typeValue: "",
    packageValue: "",
  },
  buttonAction: {
    page: "",
    action: "",
  },
  addButtonDisabled: false,
  updateButtonDisabled: false,
};

const headerSlice = createSlice({
  name: "header",
  initialState,
  reducers: {
    setPage: (state, { payload }) => {
      state.page = payload;
    },
    setPageTitle: (state, { payload }) => {
      state.title = payload;
    },
    setSearchInput: (state, { payload }) => {
      state.searchInput = payload;
    },
    setType: (state, { payload }) => {
      state.typeValue = payload;
    },
    setIndustry: (state, { payload }) => {
      state.industryValue = payload;
    },
    setPackage: (state, { payload }) => {
      state.packageValue = payload;
    },
    setOrganisation: (state, { payload }) => {
      state.organisationValue = payload;
    },
    setAccess: (state, { payload }) => {
      state.accessValue = payload;
    },
    setReports: (state, { payload }) => {
      state.reportsValue = payload;
    },
    setOrganisations: (state, { payload }) => {
      state.organisationsValue = payload;
    },
    setCategory: (state, { payload }) => {
      state.categoryValue = payload;
    },
    setHeader: (state, { payload }) => {
      state.header = payload;
    },
    setButtonAction: (state, { payload }) => {
      state.buttonAction = payload;
    },
    setAddButtonDisabled: (state, { payload }) => {
      state.addButtonDisabled = payload;
    },
    setUpdateButtonDisabled: (state, { payload }) => {
      state.updateButtonDisabled = payload;
    },
  },
});

export const {
  setPage,
  setPageTitle,
  setSearchInput,
  setType,
  setIndustry,
  setPackage,
  setOrganisation,
  setAccess,
  setReports,
  setOrganisations,
  setCategory,
  setHeader,
  setButtonAction,
  setAddButtonDisabled,
  setUpdateButtonDisabled,
} = headerSlice.actions;
export default headerSlice.reducer;
